export const accountRoles = {
  OWNER: 'Organization owner',
  EDITOR: 'Editor'
}
